import React from 'react';

import cn from 'classnames';

import { Icon, UiButton } from '@shared/ui';

import cls from './LightboxHeader.module.css';

interface LightboxHeaderProps {
    classes?: string;
    onClose?: () => void;
}

export const LightboxHeader = ({ classes, onClose }: LightboxHeaderProps) => (
    <div className={cn(cls.LightboxHeader, [classes])}>
        <UiButton variant="text" onClick={onClose} startIcon={<Icon iconName="back" />} />
    </div>
);
